/// <reference path="../../../../app.definition.ts" />

import angular from 'angular';
import { PermissionsEnum, TargetEnum } from "@common/model/subject";
import { CacheService } from '@common/service/cache.service';
import { IConfigService } from '@common/service/config.service';
import { TeamPermissionService } from '@common/service/teamPermission.service';
import { IUserService } from '@common/service/user.service';
import { IAppRootScopeService } from '@/app/app.definition';
import { PaymentService } from '@common/service/payment.service';
import { PermissionService } from 'ecv/common/permissions';

interface IEcvCarefeedAction {
    init(): void;
    redirectAction(redirectTo: string): void;
}

class EcvCarefeedAction implements IEcvCarefeedAction {
    currentUser;
    selectedSubject;
    isDiscAllowed: boolean;
    toastrMsg: string;
    isBuildBtnDisable;
    isUploadPermited;
    checkAccessForTeamMemmber;
    isConnectBtn: boolean;
    static $inject = ['ConfigService', 'CacheService', '$rootScope', '$state', 'PaymentService', "TeamPermissionService", "PermissionService", "UserService"];
    constructor(
        private $config: IConfigService,
        private $_cache: CacheService,
        private $rootScope: IAppRootScopeService,
        private $state: ng.ui.IStateService,
        private PaymentService: PaymentService,
        private $_teamPerm: TeamPermissionService,
        private PermissionService: PermissionService,
        private UserService: IUserService
    ) {
        this.currentUser = this.$_cache.getUser();
        this.selectedSubject = this.$_cache.getCurrentSubject()
        this.isDiscAllowed = this.$_teamPerm.isDiscussionsAllowed(this.$_cache.getCurrentSubject());
        this.isConnectBtn = true;
        this.isUploadPermited = true
    }

    init(): void {
        if (this.selectedSubject) {
            this.checkAccessForTeamMemmber = {
                partyId: this.selectedSubject.teamPartyId,
                target: TargetEnum.TEAMMEMBER
            }
            this.setPermission()
            this.fetchTeamPermissions([this.selectedSubject.teamPartyId])

        }

    }
    fetchTeamPermissions = (ids: number[]) => {
        this.PermissionService.fetchPermissionsForTarget(ids).catch(e => {
            console.error(e)
        })
    }
    setPermission = () => {
        this.UserService.isUserTeammember(this.selectedSubject).then((s) => {
            this.isConnectBtn = s
            if (!s) {
                this.PermissionService.isActionAllowed(this.checkAccessForTeamMemmber.partyId, TargetEnum.DOCUMENT, PermissionsEnum.CREATE).then((isPermited) => {
                    this.isUploadPermited = isPermited
                })
            } else {
                this.isUploadPermited = true
            }
        });
        if (this.currentUser.userId === this.selectedSubject.ownerId || this.selectedSubject.coCaptain) {
            this.isBuildBtnDisable = false
        }
        else {
            this.PermissionService.isActionAllowed(this.checkAccessForTeamMemmber.partyId, TargetEnum.TEAMMEMBER, PermissionsEnum.CREATE).then((isPermited) => {
                this.isBuildBtnDisable = !isPermited
            })
        }

    }
    redirectAction = (redirectTo: string): boolean => {
        if (redirectTo == 'teams') {
            // redirect to build team page
            this.$state.go('parent-dashboard', { ref: 'build' });
        } else if (redirectTo == 'documents') {
            // redirect to documents page
            this.PaymentService.checkLimitAndProceed("document", () => {
                this.$state.go('organize', { ref: 'cf' });
            });
        } else if (redirectTo == 'discussions') {
            // redirect to discussion page
            this.PaymentService.checkLimitAndProceed("discussion", () => {
                this.$state.go('connect', { ref: 'cf' });
            });
        }
        return true;
    }
}

function carefeedAction(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/carefeedBoard/components/carefeedAction/carefeed.action.directive.html',
        replace: true,
        controller: EcvCarefeedAction,
        controllerAs: 'careFeedActionVm',

        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvCarefeedAction): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.carefeedBoard').directive('ecvCarefeedAction', carefeedAction);
